var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackChatbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 133",
    cx: 15.7109,
    cy: 15,
    r: 15,
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6646 8.77924L18.6641 8.77878C18.2575 8.3395 17.59 8.33915 17.1838 8.77901L17.1835 8.77939L11.7519 14.6858C11.7518 14.6859 11.7518 14.686 11.7517 14.6861C11.3645 15.1058 11.3635 15.81 11.7517 16.2308C11.7518 16.2309 11.7519 16.2309 11.7519 16.231L17.1827 22.1374L17.1833 22.138C17.5899 22.5773 18.2574 22.5777 18.6636 22.1378C19.0598 21.7087 19.0598 21.0219 18.6637 20.5928C18.6636 20.5927 18.6636 20.5927 18.6636 20.5926L13.9426 15.458L18.6644 10.3234C18.6644 10.3233 18.6645 10.3233 18.6645 10.3232C19.0599 9.89471 19.0596 9.20813 18.6646 8.77924Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackChatbox);
export default __webpack_public_path__ + "static/media/back_chatbox.e36a01191bf0dee4e313caa38ed7854c.svg";
export { ForwardRef as ReactComponent };